module.exports = __webpack_public_path__ + "static/img/1.2561da7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/1.png
// module id = aY3u
// module chunks = 0